import {
  type FieldValues,
  type FormItemWrapperProps,
  type UseControllerProps,
  useCustomController,
} from '@faceup/form'
import { FormItem } from '@faceup/ui'
import { MultiSelect } from '@faceup/ui-base'

type Option = {
  label: string
  value: string
}

type AFMultiSelectFormInputProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<FormItemWrapperProps, 'value' | 'defaultValue' | 'placeholder'> & {
    options: Option[]
    maxResponses: number | null
    loading?: boolean
    placeholder?: string
  }

export const AFMultiSelectFormInput = <T extends FieldValues>({
  options,
  maxResponses,
  ...props
}: AFMultiSelectFormInputProps<T>) => {
  const {
    formItemProps,
    inputProps: { value, onChange },
  } = useCustomController(props)

  const selectedOptionIds = (value as string[] | undefined) ?? []
  const isMaxReached = maxResponses !== null && selectedOptionIds.length >= maxResponses

  // Disable unselected options when max is reached
  const optionsWithDisabled = options.map(o => ({
    ...o,
    disabled: isMaxReached && !selectedOptionIds.includes(o.value),
  }))

  return (
    <FormItem {...formItemProps}>
      <MultiSelect
        value={selectedOptionIds}
        options={optionsWithDisabled}
        onChange={newOptionIds => {
          onChange(newOptionIds)
        }}
      />
    </FormItem>
  )
}
